import { type InjectedFormikProps } from "formik";

import { BdsButton, BdsIconGearSix } from "@buildertrend/components";

import { BTFormItemAutomatic } from "commonComponents/btWrappers/BTForm/BTForm";
import { RoleSelect } from "commonComponents/entity/roles/RoleSelect/RoleSelect";
import { PageSection } from "commonComponents/utilities/PageSection/PageSection";

import {
    type IInternalUserFormValues,
    type InternalUserEntity,
    type InternalUserTabKeys,
} from "entity/internalUser/InternalUserDetails/InternalUser.api.types";
import RolePermissions from "entity/internalUser/RolePermissions/RolePermissions";

interface IInternalUserPermissionsProps {
    internalUserDetails: InternalUserEntity;
    canEdit: boolean;
    onChangeActiveKey: (value: InternalUserTabKeys) => void;
    onRoleChange: (field: string, value: any) => void;
    manageRolesLink: string;
    isMfaEnabled?: boolean;
    inEditMode: boolean;
}

export function InternalUserPermissions({
    setFieldTouched,
    values,
    canEdit,
    onRoleChange,
    internalUserDetails,
    isMfaEnabled,
    manageRolesLink,
    inEditMode,
}: InjectedFormikProps<IInternalUserPermissionsProps, IInternalUserFormValues>) {
    const role = internalUserDetails.internalUser.roles.find((r) => r.id === values.role);
    const isFullAdmin =
        internalUserDetails.canView &&
        internalUserDetails.canEdit &&
        internalUserDetails.canAdd &&
        internalUserDetails.canDelete;
    const isReadOnly = !canEdit || !inEditMode;

    return (
        <PageSection title="Permissions">
            <BTFormItemAutomatic<IInternalUserFormValues> id="role" useBds>
                <RoleSelect
                    id="role"
                    data-testid="role"
                    treeData={values.roleTreeData}
                    onChange={onRoleChange}
                    onBlur={setFieldTouched}
                    value={values.role}
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                    bds
                    addonAfter={
                        isFullAdmin && (
                            <BdsButton
                                to={manageRolesLink}
                                useSPARouting
                                target="_blank"
                                testid="manage-roles"
                                displayType="tertiary"
                                ariaLabel="Manage Roles"
                                icon={<BdsIconGearSix />}
                            />
                        )
                    }
                />
            </BTFormItemAutomatic>
            {role && values.role !== -1 && (
                <RolePermissions
                    id="roles"
                    readOnly={true}
                    readOnlyMessage={false}
                    hideName={true}
                    role={role}
                    setFieldValue={onRoleChange}
                    setFieldTouched={setFieldTouched}
                    isMfaEnabled={isMfaEnabled}
                    useBds
                />
            )}
        </PageSection>
    );
}
